// dialogModalSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IsLoadingState } from "./types";

const initialState: IsLoadingState = {
  isLoading: false,
};

const isLoadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    open(state, action: PayloadAction<IsLoadingState>) {
      state.isLoading = action.payload.isLoading;
    },
  },
});

export const { open } = isLoadingSlice.actions;
export default isLoadingSlice.reducer;
